// src/Pages/novousuario.jsx

import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import MenuLateral from "../Components/MenuPrincipal/MenuLateral";
import UsuarioForm from "../Components/UsuarioForm/UsuarioForm";
import { useAuth } from "../Context/auth";

function NovoUsuario() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();
    const [mensagem, setMensagem] = useState('');
    const [loading, setLoading] = useState(false);

    async function handleCadastrarUsuario(formData) {
        setMensagem('');
        if (!formData.nome || !formData.email || !formData.senha) {
            setMensagem('Nome, E-mail e Senha são obrigatórios.');
            return;
        }
        setLoading(true);

        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/usuarios`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(formData)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Falha ao cadastrar usuário.");
            }
            navigate('/app/usuarios');
        } catch (erro) {
            setMensagem(erro.message);
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="form-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="page-header page-header-compact">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/usuarios')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="page-title page-title-sm m-0">Cadastrar <span className="highlight">Usuário</span></h1>
                    </div>
                </div>
                {mensagem && <div className="alert alert-danger mt-3">{mensagem}</div>}
                <div className="form-card-container">
                    <div className="form-container">
                        <UsuarioForm onSubmit={handleCadastrarUsuario} loading={loading} />
                    </div>
                </div>
            </div>
        </div>
    );
}
export default NovoUsuario;